import { Icon } from '@calendly/ui/components/icon';
import { Menu as BaseMenu } from '@calendly/ui/components/menu';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useViewportFit } from 'hooks/useViewportFit';
import { MenuButton } from './menu_button';
const containerIsResponsiveCss = "c17guepr";
const containerIsSmallPhoneCss = "ctwmvyo";
const containerCss = "c1oudulk";
const containerPositionCompactCss = "cevpvgu";
const wrapperPositionCompactCss = "we9v5me";
const Container = forwardRef((props, ref) => {
  const {
    isResponsive,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsResponsiveCss]: isResponsive,
    [containerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const menuContainerPullLeftCss = "mc4j78e";
const menuContainerIsTabletDownCss = "mdonz9i";
const menuContainerIsPhoneCss = "mngo62i";
const menuContainerCompactCss = "m1wbobn";
const menuContainerCss = "m12xdwpw";
const MenuContainer = forwardRef((props, ref) => {
  const {
    pullLeft,
    compact,
    ...restProps
  } = props;
  const isTabletDown = useDeviceType('isTabletDown');
  const isPhone = useDeviceType('isPhone');
  return <BaseMenu ref={ref} {...restProps} className={classNames(menuContainerCss, {
    [menuContainerCompactCss]: compact,
    [menuContainerPullLeftCss]: pullLeft,
    [menuContainerIsTabletDownCss]: isTabletDown,
    [menuContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const buttonContainerSetGapCss = "b8chyk";
const buttonContainerCss = "b1hf4kv7";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    setGap,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, {
    [buttonContainerSetGapCss]: setGap
  }, props.className)} />;
});
const defaultIconCss = "d1un1oul";
const DefaultIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(defaultIconCss, props.className)} />;
});
const selectedIconCss = "s137fg13";
const SelectedIcon = forwardRef((props, ref) => <DefaultIcon ref={ref} {...props} className={classNames(selectedIconCss, props.className)} />);
const arrowIconCss = "as1onws";
const ArrowIcon = forwardRef((props, ref) => <Icon ref={ref} {...props} className={classNames(arrowIconCss, props.className)} />);
const displayArrows = (isOpen, disableArrow) => {
  if (disableArrow) return null;
  if (isOpen) {
    return <ArrowIcon name="angle-up" data-component="angle-up" />;
  }
  return <ArrowIcon name="angle-down" data-component="angle-down" />;
};
export const Menu = ({
  buttonText,
  className,
  children,
  CustomIcon = null,
  hasSelection,
  iconName,
  isOpen,
  onClick,
  Wrapper,
  disabled = false,
  isContainerResponsive = true,
  disableArrow = false,
  compact = false,
  ...props
}) => {
  const {
    ref,
    rightConflict
  } = useViewportFit();
  const IconComponent = useCallback(() => CustomIcon ? <CustomIcon selected={hasSelection} /> : <Icon name={iconName} />, [CustomIcon, hasSelection, iconName]);
  return <Container isResponsive={isContainerResponsive} className={compact ? containerPositionCompactCss : undefined}>
      <MenuButton isOpen={isOpen} onClick={onClick} disabled={disabled} {...props}>
        <ButtonContainer setGap={!(disableArrow && !buttonText)}>
          {hasSelection ? <SelectedIcon><IconComponent /></SelectedIcon> : <DefaultIcon><IconComponent /></DefaultIcon>}
          {buttonText}
          {displayArrows(isOpen, disableArrow)}
        </ButtonContainer>
      </MenuButton>
      <Wrapper className={compact ? wrapperPositionCompactCss : undefined}>
        <MenuContainer className={className} ref={ref} pullLeft={rightConflict} compact={compact}>
          {children}
        </MenuContainer>
      </Wrapper>
    </Container>;
};

require("./menu.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./menu.js");